import { lazy } from 'react';

// Quiz Components
export const ExamList = lazy(() => import('../pages/Dashboard/ExamList'));
export const ExamDetails = lazy(() => import('../pages/Dashboard/ExamDetails'));
export const QuestionList = lazy(
  () => import('../pages/Dashboard/QuestionList'),
);
export const KanjiQuizMenu = lazy(
  () => import('../pages/Quiz/KanjiQuiz/KanjiQuizMenu'),
);
export const StageMode = lazy(
  () => import('../pages/Quiz/KanjiQuiz/StageMode'),
);
export const KanjiQuiz = lazy(
  () => import('../pages/Quiz/KanjiQuiz/KanjiQuiz'),
);
export const ParticleQuiz = lazy(
  () => import('../pages/Quiz/GrammarQuiz/ParticleQuiz'),
);
export const VocabularyQuiz = lazy(
  () => import('../pages/Quiz/GrammarQuiz/VocabularyQuiz'),
);
export const HiraganaKatakanaQuizMenu = lazy(
  () => import('../pages/Quiz/HiraganaKatakanaQuiz/HiraganaKatakanaQuizMenu'),
);
export const GrammarQuizMenu = lazy(
  () => import('../pages/Quiz/GrammarQuiz/GrammarQuizMenu'),
);
export const AudioQuiz = lazy(
  () => import('../pages/Quiz/HiraganaKatakanaQuiz/AudioQuiz'),
);
export const KanaQuiz = lazy(
  () => import('../pages/Quiz/HiraganaKatakanaQuiz/KanaQuiz'),
);

// Practice Components
export const HiraganaKatakanaPracticeMenu = lazy(
  () =>
    import('../pages/HiraganaKatakanaPractice/HiraganaKatakanaPracticeMenu'),
);
export const HiraganaPractice = lazy(
  () => import('../pages/HiraganaKatakanaPractice/HiraganaPractice'),
);
export const KatakanaPractice = lazy(
  () => import('../pages/HiraganaKatakanaPractice/KatakanaPractice'),
);

// Test Components
export const TestQuizMenu = lazy(
  () => import('../pages/Quiz/TestQuiz/TestQuizMenu'),
);
export const TestQuiz = lazy(
  () => import('../pages/Quiz/TestQuiz/MiniTest/TestQuiz'),
);
export const TakeTest = lazy(
  () => import('../pages/Quiz/TestQuiz/MiniTest/TakeTest'),
);
export const ProficiencyTest = lazy(
  () => import('../pages/Quiz/TestQuiz/ProficiencyTest/ProficiencyTest'),
);
export const TakeProficiencyTest = lazy(
  () => import('../pages/Quiz/TestQuiz/ProficiencyTest/TakeProficiencyTest'),
);
export const CheckTest = lazy(
  () => import('../pages/Quiz/TestQuiz/CheckTest/CheckTest'),
);
export const TakeCheckTest = lazy(
  () => import('../pages/Quiz/TestQuiz/CheckTest/TakeCheckTest'),
);

// Dashboard Components
export const DashboardStartPage = lazy(
  () => import('../pages/Dashboard/DigitalTeachingMaterials/StartPage'),
);
export const Menu = lazy(
  () => import('../pages/Dashboard/DigitalTeachingMaterials/Menu'),
);
export const DashboardKanjiQuizMenu = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/Quiz/KanjiQuiz/KanjiQuizMenu'
    ),
);
export const DashboardKanjiQuiz = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/Quiz/KanjiQuiz/KanjiQuiz'
    ),
);
export const DashboardGrammarQuizMenu = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/Quiz/GrammarQuiz/GrammarQuizMenu'
    ),
);
export const DashboardParticleQuiz = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/Quiz/GrammarQuiz/ParticleQuiz'
    ),
);
export const DashboardVocabularyQuiz = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/Quiz/GrammarQuiz/VocabularyQuiz'
    ),
);
export const DashboardHiraganaKatakanaQuizMenu = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/Quiz/HiraganaKatakanaQuiz/HiraganaKatakanaQuizMenu'
    ),
);
export const DashboardAudioQuiz = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/Quiz/HiraganaKatakanaQuiz/AudioQuiz'
    ),
);
export const DashboardKanaQuiz = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/Quiz/HiraganaKatakanaQuiz/KanaQuiz'
    ),
);
export const DashboardHiraganaKatakanaPracticeMenu = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/HiraganaKatakanaPractice/HiraganaKatakanaPracticeMenu'
    ),
);
export const DashboardHiraganaPractice = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/HiraganaKatakanaPractice/HiraganaPractice'
    ),
);
export const DashboardKatakanaPractice = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/HiraganaKatakanaPractice/KatakanaPractice'
    ),
);
export const DashboardStageMode = lazy(
  () =>
    import(
      '../pages/Dashboard/DigitalTeachingMaterials/Quiz/KanjiQuiz/StageMode'
    ),
);

export const Home = lazy(() => import('../pages/Home'));
export const Top = lazy(() => import('../pages/Top'));
export const Login = lazy(() => import('../pages/Login'));
export const StartPage = lazy(() => import('../pages/StartPage'));
export const ResetPassword = lazy(() => import('../pages/ResetPassword'));
export const OrganizationList = lazy(
  () => import('../pages/Dashboard/OrganizationList'),
);
export const StudentList = lazy(() => import('../pages/Student/StudentList'));
export const TeacherList = lazy(() => import('../pages/Teacher/TeacherList'));
export const NotFound = lazy(() => import('../pages/NotFound'));
export const StudentDetails = lazy(
  () => import('../pages/Student/StudentDetails'),
);
export const StudentProfile = lazy(
  () => import('../pages/Student/StudentProfile'),
);
export const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
export const TermsOfUsage = lazy(() => import('../pages/TermsOfUsage'));
export const Law = lazy(() => import('../pages/Law'));
